import { css } from '@emotion/react';
import { useSession } from 'next-auth/react';
import { useRouter } from 'next/router';
import * as React from 'react';
import { useEffect } from 'react';
import IconsLogos from '../../components/elements/IconsLogos';
import DefaultHeader from '../../components/headers/DefaultHeader';
import Metas from '../../components/headers/Metas';
import SubHeader from '../../components/headers/SubHeader';
import MainLayout from '../../components/layouts/mainLayout';
import { secondarySpaceMarginAsGapFlex } from '../../components/share';
import Loader from '../../components/utils/Loader';
import { routesIn } from '../../services/bridge';
import { logErrorAsyncMessage, logMessage } from '../../services/common';
import { IStaticData, generalData } from '../../services/data';
import { ITheme } from '../../services/style/type';

const componentCSS = {
  self: (props: ITheme) =>
    css({
      '& h1': {
        color: '#FA5230',
        textTransform: 'uppercase',
      },
      '& h3': {
        color: props.colorsText.primary,
        textAlign: 'center',
        fontWeight: 'bold',
        '&::first-letter': {
          textTransform: 'uppercase',
        },
      },
      '& svg': {
        fontSize: '10rem',
        color: props.background.primary,
      },
    }),
  header: css({
    '& .header_entry_value': {
      display: 'none',
    },
  }),
  paragraph: (props: ITheme) =>
    css({
      color: props.colorsText.fourth,
      fontWeight: '500',
      gap: '1px',
      '& span': {
        marginLeft: '.3rem',
      },
    }),
};

const Elements = () => {
  const { locale } = useRouter();
  return (
    <>
      {' '}
      <IconsLogos type={'lock'} />
      <h1> {generalData[locale].agreement.text[0]}</h1>
      <h3> {generalData[locale].agreement.text[1]}</h3>
    </>
  );
};

const CheckBoxes = ({ handleChange, checked }) => {
  const [isEmailChecked, setIsEmailChecked] = React.useState(true);
  const { status } = useSession();
  const router = useRouter();
  useEffect(() => {
    if (status === 'authenticated') router.push(routesIn.eng.home.link);
  }, [status]);

  useEffect(() => {
    let isComponentMounted = true;
    const updateLocalStorage = async () => {
      try {
        if (!isComponentMounted) return;
        localStorage.setItem(
          'authorisationEmailing',
          isEmailChecked.toString()
        );
        localStorage.setItem(
          'date',
          new Date().toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          })
        );
      } catch (error) {
        logMessage(`${logErrorAsyncMessage(
          'agreement/index',
          'updateLocalStorage'
        )},
    ${error}`);
      }
    };
    updateLocalStorage();
    return () => {
      // This cleanup function will run when the component unmounts
      isComponentMounted = false;
    };
  }, [isEmailChecked]);

  useEffect(() => {
    if (checked) {
      (() => {
        router.push(
          `${locale}/auth/signin?callbackUrl=${process.env.NEXTAUTH_URL}${router.asPath}`
        );
      })();
    }
  }, [checked]);
  const handleEmail = () => setIsEmailChecked(!isEmailChecked);
  const { locale } = useRouter();
  return (
    <div className="flex_column" css={secondarySpaceMarginAsGapFlex}>
      <div className="flex_align_center_no_wrap space_btw_icon_text">
        <input
          type="checkbox"
          checked={checked}
          onChange={handleChange}
          data-testid="agreement-policy-checked"
        ></input>
        <div css={componentCSS.paragraph}>
          <div
            onKeyDown={(event) => {
              if (event.key === 'Enter') handleChange;
            }}
            role="button"
            tabIndex={0}
            onClick={handleChange}
            className="agreement_text"
            style={{ display: 'inline' }}
          >
            <span className="font_size_22_light">
              {' '}
              {generalData[locale].agreement.text[2]}
            </span>
          </div>
          <a
            href={routesIn.eng.politicOfPrivacy[locale].link}
            target="_blank"
            rel="noreferrer"
          >
            <span
              className="agreement_text font_size_22_light"
              css={{
                textDecoration: 'underline',
                color: 'blue !important',
                marginLeft: '0.3rem !important',
              }}
            >
              {generalData[locale].agreement.text[3]}
            </span>
          </a>
        </div>
      </div>
      <div className="flex_align_center_justify_center space_btw_icon_text">
        <input
          type="checkbox"
          checked={isEmailChecked}
          onChange={handleEmail}
          data-testid="email-checked"
        />
        <span className="agreement_text font_size_22_light">
          {generalData[locale].agreement.text[4]}
        </span>
      </div>
    </div>
  );
};
const index: React.FC<IStaticData> = () => {
  const [checked, setChecked] = React.useState(false);
  const handleChange = () => setChecked(!checked);
  const { locale } = useRouter();
  return (
    <>
      <Metas complement={generalData[locale].navigations[1]} />
      <div css={componentCSS.header}>
        <DefaultHeader />
      </div>
      <SubHeader />
      <MainLayout>
        {checked && <Loader typeLoader="v2" />}
        <div
          css={componentCSS.self}
          className="flex_column_center_center agreement_page"
        >
          <Elements />
          <CheckBoxes handleChange={handleChange} checked={checked} />
        </div>
      </MainLayout>
    </>
  );
};
export default index;
